import { ENDPOINTS } from 'constants/endpoints';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { getDefaultHeaders, post } from '__utils/ajax-wrapper';
import { getEncryptedUserId, getQueryParamsFromString } from '__utils/common-utils';
import useFlashToggler from 'hooks/use-flash-toggler';
import resolveURLParams from '__utils/url-params-resolver';
import { useHistory } from 'react-router-dom';
import ProfileViewSelector from '../profile-view.selector';
import { propsToJS } from '__utils/immutable-to-js';
import { getDataFromKycCookie } from '__utils/storage';
import { signzyImgToUrl, signzyChequeImgToUrl } from './signzy-populate-helper';
import { compareBusinessTypes, compareOtherTypes, compareServiceTypes, } from '__utils/helpers';

const SignzyPopulate: React.FC = () => {
    const history = useHistory();
    const flash = useFlashToggler();
    const { requestId } = getQueryParamsFromString(window.location.search);
    const { profileView, nameInHeader } = propsToJS(useSelector(ProfileViewSelector));
    let occupationType: any = undefined;
    useEffect(() => {
        post(resolveURLParams(`${ENDPOINTS.SIGNZY_AUTO_POPULATE}/${requestId}`, { ucc: getEncryptedUserId() }, {}), getEncryptedUserId(), getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.data?.occupationCode)
                {
                    if (compareServiceTypes(response?.response?.data?.occupationCode)) occupationType = "S";
                    else if (compareBusinessTypes(response?.response?.data?.occupationCode)) occupationType = "B";
                    else if (compareOtherTypes(response?.response?.data?.occupationCode)) occupationType = "O";
                }
                if (response?.response?.data?.cancelledChequeURL)
                {
                    signzyChequeImgToUrl(ENDPOINTS.POST_CANCEL_UPLOAD_CHEQUE, response?.response?.data?.cancelledChequeURL)
                        .then((signUrl: any) => signUrl)
                        .then((signUrl: any) => {
                            signzyImgToUrl(ENDPOINTS.UPLOAD_SIGNATURE_PIC, response?.response?.data?.signatureURL)
                                .then((chequePicUrl: any) => {
                                    const personalDetailsData = { ...profileView, ...{ pan: getDataFromKycCookie()?.pan, panStatus: getDataFromKycCookie()?.rawStatus, name: nameInHeader }, ...response?.response?.data, address:response?.response?.data?.address.substring(0,40), signatureURL: signUrl, cancelledChequeURL: chequePicUrl, occupationType: occupationType };
                                    post(resolveURLParams(ENDPOINTS.POST_SAVE_PROFILE_DETAILS, {}, { ucc: getEncryptedUserId() }), personalDetailsData, getDefaultHeaders(), true)
                                        .subscribe((response: AjaxResponse | AjaxError) => {
                                            if (response?.status === 200)
                                            {
                                                history.push('/profile/personal-details');
                                            }
                                            else
                                            {
                                                flash.error("Something went wrong. Please try again later")
                                            }
                                        }, (error: AjaxError) => {
                                            flash.error("Something went wrong. Please try again later")
                                        });
                                });
                        });
                }
            }, (error: AjaxError) => {
                flash.error("Unable to redirect. Please try again later.")
            });
    }, []);

    return (
        <div>

        </div>
    )
}
export default SignzyPopulate;